import PurchaseFunnel from './PurchaseFunnel';

export default (props) => <PurchaseFunnel {...props} />;
